import type { Action } from '@ngrx/store';
import type { FieldMap } from 'angular2-query-builder/dist/components';
import { createReducer, on } from '@ngrx/store';
import * as FieldMapActions from './field-map.actions';

export interface OrderFieldMapState {
  fieldMap: FieldMap;
  isLoaded: boolean;
  loading: boolean;
  error: Error | null;
}

export const initialFieldMapState: OrderFieldMapState = {
  fieldMap: {},
  isLoaded: false,
  loading: false,
  error: null,
};

const reducer = createReducer(
  initialFieldMapState,
  on(FieldMapActions.saveOrderFieldMap, (state, { orderFieldMap }) => ({ ...state, fieldMap: orderFieldMap })),
  on(FieldMapActions.getOrderFieldMap, state => ({ ...state, loading: true, error: null })),
  on(FieldMapActions.markOrderFieldMapLoaded, state => ({ ...state, isLoaded: true, error: null })),
  on(FieldMapActions.setLoading, (state, { value }) => ({ ...state, loading: value })),
  on(FieldMapActions.setError, (state, { value }) => ({ ...state, error: value, loading: false })),
);

export function fieldMapReducer(state: OrderFieldMapState | undefined, action: Action): OrderFieldMapState {
  return reducer(state, action);
}
